// ClienteLayout.tsx
import React from 'react';
import Navbar from './Navbar';
import TopBar from './Topbar';
import { Outlet } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext.tsx';
import HexagonCornerDecoration from '../common/HexagonCornerDecoration.tsx';

const ClienteLayout = () => {
    const { isDark } = useTheme();

    return (
        <div
            className="flex flex-col h-screen overflow-hidden relative"
            style={{
                background: isDark
                    ? 'linear-gradient(135deg, #0b0614 0%, #150a26 50%, #200d36 100%)'
                    : 'linear-gradient(135deg, #f8fafc 0%, #fdf8fc 50%, #f7effb 100%)',
                color: isDark ? '#f8fafc' : '#0f172a',
                fontFamily: "'DM Sans', sans-serif",
                transition: 'background 0.35s ease, color 0.35s ease',
            }}
        >
            {/* Malla hexagonal comentada temporalmente para ver el dashboard sin hexágonos */}
            {/* <HexagonCornerDecoration
                variant="horizontal-degrade"
                direction="left-to-right"
                opacity={isDark ? 0.38 : 0.22}
                style={{
                    position: 'fixed',
                    inset: 0,
                    width: '100vw',
                    height: '100vh',
                    pointerEvents: 'none',
                    zIndex: 0,
                }}
            /> */}

            {/* Resplandores ambientales de identidad Co Marca */}
            <div style={{
                position: 'fixed',
                top: '-120px',
                right: '-100px',
                width: '500px',
                height: '500px',
                background: isDark
                    ? 'radial-gradient(circle, rgba(193, 52, 139, 0.14) 0%, transparent 70%)'
                    : 'radial-gradient(circle, rgba(193, 52, 139, 0.06) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />
            <div style={{
                position: 'fixed',
                bottom: '-100px',
                left: '-100px',
                width: '450px',
                height: '450px',
                background: isDark
                    ? 'radial-gradient(circle, rgba(97, 37, 123, 0.18) 0%, transparent 70%)'
                    : 'radial-gradient(circle, rgba(97, 37, 123, 0.05) 0%, transparent 70%)',
                borderRadius: '50%',
                pointerEvents: 'none',
                zIndex: 0,
            }} />

            {/* Cabecera y Navegación de Plataforma */}
            <div style={{ position: 'relative', zIndex: 30 }}>
                <TopBar />
                <div style={{
                    borderBottom: isDark
                        ? '1px solid rgba(193, 52, 139, 0.20)'
                        : '1px solid rgba(0, 0, 0, 0.06)',
                    transition: 'border-color 0.3s ease',
                }}>
                    <Navbar />
                </div>
            </div>

            {/* Área de Contenido Principal (con scroll transparente que deja lucir los hexágonos) */}
            <div
                className="flex-1 overflow-y-auto custom-scroll relative"
                style={{
                    zIndex: 10,
                    background: 'transparent',
                }}
            >
                <Outlet />
            </div>
        </div>
    );
};

export default ClienteLayout;